import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export async function exportPDF(
    elementId,
    filename = 'download.pdf',
    scale = 1,
    marginTop = 15,      // 上边距 mm
    marginBottom = 15,   // 下边距 mm
    marginLeft = 20,     // 左边距 mm
    marginRight = 20     // 右边距 mm
) {
    const element = document.getElementById(elementId);
    if (!element) return;

    const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#fff',
    });

    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    // 可绘图区域
    const drawableWidth = pageWidth - marginLeft - marginRight;
    const drawableHeight = pageHeight - marginTop - marginBottom;

    // 整张图的尺寸
    const imgFullWidth = drawableWidth;                     // 最终 PDF 中图的宽度
    const imgFullHeight = (canvas.height * imgFullWidth) / canvas.width;

    // 总页数
    const totalPages = Math.ceil(imgFullHeight / drawableHeight);

    for (let page = 0; page < totalPages; page++) {
        if (page > 0) pdf.addPage();

        // 计算源 canvas 的裁剪区域
        const sourceY = page * drawableHeight * (canvas.height / imgFullHeight);
        const sourceHeight = Math.min(
            drawableHeight * (canvas.height / imgFullHeight),
            canvas.height - sourceY
        );

        // 临时裁剪 canvas
        const pageCanvas = document.createElement('canvas');
        pageCanvas.width = canvas.width;
        pageCanvas.height = sourceHeight;
        const ctx = pageCanvas.getContext('2d');
        ctx.drawImage(
            canvas,
            0,
            sourceY,
            canvas.width,
            sourceHeight,
            0,
            0,
            pageCanvas.width,
            pageCanvas.height
        );

        // 添加到 PDF，注意 x 从 marginLeft 开始
        pdf.addImage(
            pageCanvas.toDataURL('image/png', 1.0),
            'PNG',
            marginLeft,
            marginTop,
            drawableWidth,
            (pageCanvas.height * drawableWidth) / pageCanvas.width
        );
    }

    pdf.save(filename);
}










// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';

// export async function exportPDF(elementId, filename = 'download.pdf', scale = 1) {
//     const element = document.getElementById(elementId);

//     /* ---------- 1. 临时整体放大 ---------- */
//     // const originalStyle = element.style.cssText;
//     // element.style.transformOrigin = 'top left';
//     // element.style.transform = `scale(${scale})`;
//     // element.style.width = `${element.offsetWidth}px`; // 防止宽度被缩放后变小
//     // element.offsetHeight; // 读取一下，触发 reflow
//     /* ---------- 2. 等待浏览器一次重绘（必加，否则样式不生效） ---------- */
//     // await new Promise(requestAnimationFrame);
//     // console.log('放大后容器实际像素宽高：', element.offsetWidth, element.offsetHeight);
//     const canvas = await html2canvas(element, {
//         scale: 2,
//         useCORS: true,
//         allowTaint: true,
//         backgroundColor: '#fff',
//         // width: element.offsetWidth * scale,  // 画布宽高也要放大
//         // height: element.offsetHeight * scale
//     });
//     /* ---------- 4. 恢复原始样式 ---------- */
//     // element.style.cssText = originalStyle;

//     // const imgData = canvas.toDataURL('image/jpeg', 1.0);
//     const pdf = new jsPDF('p', 'mm', 'a4');
//     const pageWidth = pdf.internal.pageSize.getWidth();
//     const pageHeight = pdf.internal.pageSize.getHeight();

//     // const imgProps = pdf.getImageProperties(imgData);
//     const imgWidth = pageWidth;
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;

//     let heightLeft = imgHeight;
//     let position = 0;

//     const imgData = canvas.toDataURL('image/png', 1.0);


//     /* 多页循环 */
//     while (heightLeft > 0) {
//         pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
//         heightLeft -= pageHeight;
//         position -= pageHeight;
//         if (heightLeft > 0) pdf.addPage();
//     }


//     pdf.save(filename);
// }




// import html2canvas from 'html2canvas'
// import jsPDF from 'jspdf'

// /**
//  * 导出区域为 PDF
//  * @param {String} eleId        要导出的 DOM id
//  * @param {String} fileName     下载文件名
//  * @param {String} orientation  'p'（竖向） | 'l'（横向）
//  */
// export function exportPDF(
//   eleId,
//   fileName = 'document.pdf',
//   orientation = 'p'
// ) {
//   const ele = document.getElementById(eleId)
//   if (!ele) return Promise.reject(new Error('元素不存在'))

//   return html2canvas(ele, {
//     useCORS: true,          // 允许跨域图片
//     scale: 2                // 提高清晰度
//   }).then(canvas => {
//     const imgData = canvas.toDataURL('image/png')
//     const pdf = new jsPDF({
//       orientation,
//       unit: 'mm',
//       // 页面尺寸 = 画布尺寸 / 96 * 25.4
//       format: [
//         canvas.width / 96 * 25.4,
//         canvas.height / 96 * 25.4
//       ]
//     })
//     pdf.addImage(
//       imgData,
//       'PNG',
//       0,
//       0,
//       pdf.internal.pageSize.getWidth(),
//       pdf.internal.pageSize.getHeight()
//     )
//     pdf.save(fileName)
//   })
// }